module.exports = __webpack_public_path__ + "static/media/cross.cdfc3e5c.svg";